<template>
    <div class="content mt20">
       <div class="account-content bgfff">
            <taskOrdersMenu></taskOrdersMenu>
       </div>
       <div class="account-bd">&nbsp;</div>
       <div class="bgfff">
            <div class="bd clearfix">
                <span class="fl mt5">审核状态：</span>
                <div class="dropdown-toggle fl">
                    <div class="dropdown">
                        <span>{{typeWord}}</span>
                        <i class="icons icons-down fr"></i>
                    </div>
                    <div class="drop-down">
                        <ul class="dropdown-menu dropdown-menu1" role="menu">
                            <li @click="OrderType(0)">
                               <a :class="(typeCurrent==0)?'active':''" href="javascript:void(0);">全部</a>
                            </li>
                            <li @click="OrderType(1)">
                               <a :class="(typeCurrent==1)?'active':''" href="javascript:void(0);">审核中</a>
                            </li>
                            <li @click="OrderType(2)">
                               <a :class="(typeCurrent==2)?'active':''" href="javascript:void(0);">通过</a>
                            </li>
                            <li @click="OrderType(3)">
                               <a :class="(typeCurrent==3)?'active':''" href="javascript:void(0);">退回</a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="search fr">
                    <div class="search fl">
                        <input type="text" v-model="Searchtitle" class="input-text" name="search" placeholder="请输入媒体号">
                    </div>
                    <button class="btn btn-blue" @click="searcBotton"><i class="icons search-icon"></i></button>
                </div>
            </div>
            <div class="">
                <div class="clearfix listloop-wrap profile active" v-for="(item,index) in mediaList" :key="index">
                    <div class="clearfix">
                        <div class="fl profile-img">
                            <img :src="item.cover" width="180" height="100" />
                        </div>
                        <div class="fr profile-btn mt40">
                            <div class="details-a" :class="curr==index?'active':''" @click="ViewDetails(item.id,index,item.status)"><span class="color-blue">查看详情</span><i class="icons icons-down fr"></i></div>
                        </div>
                        <div class="profile-info">
                            <h3 class="profile-tit">{{item.title}}</h3>
                            <div class="profile-status">
                                <span class="color_gray time"><i class="icons time-icon"></i>发送时间：{{item.pushTime}}</span>
                                <span class="ml10 cr1ab968 read" :class="[{'cr1ab968':item.status==1},{'color-orange':item.status==2},{'color-red':item.status==3}]">状态：{{item.statusZh}}</span>
                            </div>
                            <p class="profile-art mt30">
                                <span class="fs12">发布媒体号：</span>
                                <span class="ml10 read" v-for="(item1,index) in item.media" :key="index"><i class="icons" :class="[{'wx-icon':item1.type==1},{'wb-icon':item1.type==2},{'tt-icon':item1.type==3}]"></i>{{item1.nickname}}</span>
                            </p>
                        </div>
                    </div>
                    <div class="handle-content mt10" v-show="curr==index">
                        <table class="table table-issue" width="100%" border="0" cellpadding="0" cellspacing="0" v-if="status==0">
                            <colgroup>
                                <col width="25%">
                                <col width="25%">
                                <col width="25%">
                                <!-- <col width="10%"> -->
                            </colgroup>
                            <thead>
                                <tr>
                                    <th>审核状态</th>
                                    <th>当前处理人</th>
                                    <th>审核时间</th>
                                    <!-- <th>文章链接</th> -->
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        {{orderList.statusZh}}
                                    </td>
                                    <td>{{orderList.username}}</td>
                                    <td>{{orderList.auditTime}}</td>
                                    <!-- <td>
                                        <a :href="orderList.url" class="color-blue">复制链接</a>
                                    </td> -->
                                </tr>
                            </tbody>
                        </table>
                        <table class="table table-issue" width="100%" border="0" cellpadding="0" cellspacing="0" v-if="status==1">
                            <colgroup>
                                <col width="25%">
                                <col width="25%">
                                <col width="25%">
                            </colgroup>
                            <thead>
                                <tr>
                                    <th>审核状态</th>
                                    <th>当前处理人</th>
                                    <th>接收时间</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        {{orderList.statusZh}}
                                    </td>
                                    <td>{{orderList.username}}</td>
                                    <td>{{orderList.auditTime}}</td>
                                </tr>
                            </tbody>
                        </table>
                        <table class="table table-issue" width="100%" border="0" cellpadding="0" cellspacing="0" v-if="status==2">
                            <colgroup>
                                <col width="25%">
                                <col width="25%">
                                <col width="25%">
                                <col width="15%">
                            </colgroup>
                            <thead>
                                <tr>
                                    <th>审核状态</th>
                                    <th>当前处理人</th>
                                    <th>退回理由</th>
                                    <th>退回时间</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        {{orderList.statusZh}}
                                    </td>
                                    <td>{{orderList.username}}</td>
                                    <td>
                                        {{orderList.remark}}
                                    </td>
                                    <td>{{orderList.auditTime}}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
             <!-- 分页 -->
            <page class="mt20" :currentPage.sync="currentPage" :limit.sync="limit" :totalCount="totalCount" @turn="getTableData"></page>
       </div>
  	</div>
</template>
<script>
import Page from '@/components/page'
import taskOrdersMenu from './taskOrdersMenu.vue'
export default {
    components:{Page,taskOrdersMenu},
    data() {
        return {
           mediaList:[],//指令列表
           orderList:'',//指令详情列表
           currentPage:1,//当前条数
           limit:5,//每页显示条数
           totalCount:0,//总条数
           typeId:1,//id
           imgUrl:'',//图片url
           typeCurrent:0,//指令类型
           Searchtitle:'',//搜索
           typeWord:'全部',//指令类型文字
           curr:-1,
           pid:'',//指令详情pid
           status:'',//指令详情status
        }
    },
    mounted() {
		let that = this;
        if(that.$route.query.type==undefined){
            that.typeWord = '全部'
            that.typeCurrent = 0;
        }else{
            that.typeWord = that.$route.query.type1;
            that.typeCurrent = that.$route.query.type;
            
        }
        that.dataAjax(0);
    },
    created() {
		
    },
    methods: {
        ViewDetails(id,index,status){//点击展开详情
            let that = this;
            that.pid= id;
            that.status = status;
            that.curr = that.curr == index ? -1 : index; 
            if(that.curr == -1){
                return;
            }else{
                that.dataAjax2();
            }
            
                      
        },
       searcBotton(){//搜索
            let that = this;
            if(that.Searchtitle==''){
                return;
            }
            that.dataAjax(0);
        },
        OrderType(type){//指令类型选择
            let that = this;
            that.typeCurrent = type;
            if(type==0){
                that.typeWord = '全部'
            }else if(type==1){
                that.typeWord = '审核中'
            }else if(type==2){
                that.typeWord = '通过'
            }else if(type==3){
                that.typeWord = '退回'
            }
            that.$router.push({
                path: '/taskOrders/taskMyArticle',
                query: {
                    type: type,
                    type1:that.typeWord,
                }
            });
            that.typeCurrent = that.$route.query.type;
            that.typeWord = that.$route.query.type1;

            that.dataAjax(0);
        },
        getTableData(type){//分页
            let that = this;
            type = that.currentPage;

            that.dataAjax();
        },
        dataAjax(cPage){//文章发布列表
            let that = this;
            let url = '';
            cPage = 1;
            if(cPage ==0){
                that.currentPage =1;
            }
            that.$api.post('/audit/mypublish',{page:that.currentPage,pagesize:that.limit,status:that.typeCurrent,title:that.Searchtitle},r=>{
                that.$parent.returnCode(r,function(){
                   that.mediaList=r.data.data;
                   that.totalCount = Number(r.data.total);
                   
              })
            })
       },
       dataAjax2(){//文章发布详情
            let that = this;
            let url = '';
            that.$api.post('/audit/auditdetail',{id:that.pid},r=>{
                that.$parent.returnCode(r,function(){
                    that.orderList=r.data;
              })
            })
       }
       
	}
}
</script>



// WEBPACK FOOTER //
// src/page/taskOrders/taskMyArticle.vue